import React from 'react';

// One-click betting loading component
export const OneClickBettingLoader: React.FC<{}> = ({
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-6 bg-black/80 rounded-lg min-w-[250px] min-h-[150px]">
      {/* Simple spinner loader */}
      <div
        className="w-10 h-10 border-4 border-t-[var(--ion-color-primary)] rounded-full animate-spin"
        style={{ borderWidth: '4px' }}
      />

      {/* Processing text */}
      <div className="text-white text-sm font-semibold text-center leading-relaxed">
        Your bet is being processed...
      </div>

      <div className="text-gray-400 text-xs text-center">
        Please wait
      </div>
    </div>
  );
};